/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDialogController', MemberManagementDialogController);

    MemberManagementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'AlertService', 'DataUtils', 'entity', 'MemberManagement', 'User'];

    function MemberManagementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, AlertService, DataUtils, entity, MemberManagement, User) {
        var vm = this;

        vm.member = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            MemberManagement.update(vm.member, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            //$scope.$emit('askApp:profileUpdate', MemberManagement.get({id : vm.member.id}));
            AlertService.success("Mitglied " + vm.member.user.login + " wurde erfolgreich aktualisiert.");
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.birthdate = false;

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.matriculationCertificate = base64Data;
                        profile.matriculationCertificateContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
